import React from "react";
import { MarkdownWithTOC } from "../../components/MarkdownWithTOC/MarkdownWithTOC";

export function Guides() {
  return <MarkdownWithTOC markdownName="guides" />;
}
